import React from "react";

const Sessions = ({
  studentId,
  setStudentId,
  onLogin,
  activeId,
  taken,
  available,
  upcoming,
  registrations,
  onJoin,
  onRequest,
}) => {
  return (
    <section
      id="sessions"
      style={{ padding: "4rem 2rem", background: "var(--bg-dark)" }}
    >
      <div
        style={{ maxWidth: "1000px", margin: "0 auto", textAlign: "center" }}
      >
        <h2
          style={{
            fontFamily: "var(--font-head)",
            color: "var(--gold)",
            fontSize: "2rem",
          }}
        >
          Student Portal
        </h2>

        {/* ID Login Area */}
        <div
          style={{
            margin: "2rem 0",
            display: "flex",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <input
            type="text"
            placeholder="Student ID"
            value={studentId}
            onChange={(e) => setStudentId(e.target.value.toUpperCase())}
            style={{
              padding: "0.8rem",
              borderRadius: "4px",
              border: "1px solid var(--gold)",
              background: "rgba(255,255,255,0.05)",
              color: "white",
              width: "250px",
            }}
          />
          <button className="btn" onClick={() => onLogin(studentId)}>
            Enter
          </button>
        </div>

        {!activeId ? (
          <div style={{ marginTop: "3rem" }}>
            <h3 style={{ color: "var(--gold)", marginBottom: "1.5rem" }}>
              Upcoming Sessions
            </h3>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "1.5rem",
                textAlign: "left",
              }}
            >
              {/* Only showing Available classes to public, hiding dates/buttons */}
              {available.map((c) => (
                <div
                  key={c.id}
                  style={{
                    padding: "1rem",
                    border: "1px solid rgba(255,255,255,0.1)",
                    borderRadius: "8px",
                  }}
                >
                  <strong
                    style={{
                      display: "block",
                      color: "var(--gold)",
                      fontSize: "1.1rem",
                    }}
                  >
                    {c.title}
                  </strong>
                  <p
                    style={{
                      fontSize: "0.9rem",
                      color: "var(--text)",
                      opacity: 0.8,
                      marginTop: "8px",
                    }}
                  >
                    {c.description}
                  </p>
                </div>
              ))}
            </div>
            {available.length === 0 && (
              <p style={{ color: "var(--muted)" }}>
                No sessions currently scheduled.
              </p>
            )}
          </div>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1.5fr",
              gap: "3rem",
              textAlign: "left",
              marginTop: "3rem",
            }}
          >
            {/* Left Column: History */}
            <div>
              <h3
                style={{
                  color: "var(--gold)",
                  borderBottom: "1px solid rgba(212, 175, 55, 0.3)",
                  paddingBottom: "10px",
                }}
              >
                Your History
              </h3>
              {taken.map((c) => (
                <div
                  key={c.id}
                  style={{
                    margin: "1rem 0",
                    padding: "0.5rem 0",
                    borderBottom: "1px solid rgba(255,255,255,0.05)",
                  }}
                >
                  <strong style={{ display: "block" }}>{c.title}</strong>
                  <span style={{ fontSize: "0.8rem", color: "var(--muted)" }}>
                    Completed
                  </span>
                </div>
              ))}
              {taken.length === 0 && (
                <p style={{ color: "var(--muted)" }}>
                  No completed classes found.
                </p>
              )}
            </div>

            {/* Right Column: Available & Request */}
            <div>
              <h3
                style={{
                  color: "var(--gold)",
                  borderBottom: "1px solid rgba(212, 175, 55, 0.3)",
                  paddingBottom: "10px",
                }}
              >
                Available Sessions
              </h3>
              {available.map((c) => {
                // Check if this student is already in the Google Sheet for this class
                const isJoined = registrations.some(
                  (r) =>
                    r.studentId === activeId &&
                    r.classId === c.id &&
                    r.type === "joined"
                );

                return (
                  <div
                    key={c.id}
                    style={{
                      marginBottom: "1.5rem",
                      padding: "1rem",
                      background: "rgba(255,255,255,0.02)",
                      borderRadius: "8px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                      }}
                    >
                      <div>
                        <strong style={{ fontSize: "1.1rem" }}>
                          {c.title}
                        </strong>
                        <p
                          style={{
                            color: "var(--gold)",
                            fontSize: "0.85rem",
                            margin: "4px 0",
                            fontWeight: "bold",
                          }}
                        >
                          {c.date || "Date TBD"} {c.time && ` @ ${c.time}`}
                        </p>
                      </div>
                      <button
                        className={isJoined ? "btn-joined" : "btn-small"}
                        onClick={() => !isJoined && onJoin(c.id)}
                        disabled={isJoined}
                        style={{ padding: "5px 15px", fontSize: "0.8rem" }}
                      >
                        {isJoined ? "✓ Joined" : "Join Roster"}
                      </button>
                    </div>
                    <p
                      style={{
                        fontSize: "0.9rem",
                        color: "var(--text)",
                        marginTop: "8px",
                        opacity: 0.8,
                      }}
                    >
                      {c.description}
                    </p>
                  </div>
                );
              })}

              <h3
                style={{
                  color: "var(--gold)",
                  borderBottom: "1px solid rgba(212, 175, 55, 0.3)",
                  paddingBottom: "10px",
                  marginTop: "2rem",
                }}
              >
                Request a Class
              </h3>
              {upcoming.map((c) => {
                const isRequested = registrations.some(
                  (r) =>
                    r.studentId === activeId &&
                    r.classId === c.id &&
                    r.type === "request"
                );

                return (
                  <div
                    key={c.id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "1rem",
                    }}
                  >
                    <span>{c.title}</span>
                    <button
                      className="btn-outline"
                      onClick={() => !isRequested && onRequest(c.id)}
                      disabled={isRequested}
                    >
                      {isRequested ? "Requested" : "Request"}
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Sessions;
